import React from 'react'
import MunicipalBuildings from './MunicipalBuildings'

const BuildingContest = () => {
  return (
    <div>
      <MunicipalBuildings isHomePage={false} />
    </div>
  )
}

export default BuildingContest
